export default {"src":"/_next/static/media/logo.5768e71e.svg","height":54,"width":193};